'use client';

import React from 'react';
import type { CreateFlow } from '@/utils/analytics-events';
import { FORMAT_COPY } from '@/lib/create-flow/format-copy';

const FOCUS_RING =
  'focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-marigold-deep';

/** Shown when the idea text names the other format; offers a switch that keeps photo and idea. */
export function FormatMismatchNotice({
  flow,
  onSwitch,
  onDismiss,
}: {
  flow: CreateFlow;
  onSwitch: () => void;
  onDismiss: () => void;
}) {
  const copy = FORMAT_COPY[flow];
  const { mismatchBody: body, noun } = copy;
  const i = body.indexOf(noun);
  return (
    <div role="status" className="rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950">
      <p>
        <strong>{copy.mismatchTitle}</strong>{' '}
        {i < 0 ? (
          body
        ) : (
          <>
            {body.slice(0, i)}
            <strong>{noun}</strong>
            {body.slice(i + noun.length)}
          </>
        )}
      </p>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          onClick={onSwitch}
          className={`min-h-11 rounded-lg bg-purple-600 px-4 py-2 font-semibold text-white ${FOCUS_RING}`}
        >
          {copy.mismatchAccept}
        </button>
        <button
          type="button"
          onClick={onDismiss}
          className={`min-h-11 rounded-lg border border-purple-600 bg-white px-4 py-2 font-semibold text-purple-700 ${FOCUS_RING}`}
        >
          {copy.mismatchDismiss}
        </button>
      </div>
    </div>
  );
}
